import { createAppSelector } from './utils'

export const selectRoleOptions = createAppSelector(
  [(state) => state.role.roles],
  (roles) => {
    return roles.map((role) => {
      return {
        value: role.id,
        label: role.name,
        status: role.status,
      }
    })
  },
)